import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Flex, FormLabel } from '@chakra-ui/react';
import PropType from 'prop-types';

import FormInput from '../../../../../../components/form/FormInput';
import { inputTypes } from '../../../../../../components/form/FormInput/util';
import { getValidationObject, validationTypes } from '../../../../../../constants/regexPatterns';

// TODO: strip this out
export const formLabelStyle = {
  fontSize: '13px',
  color: '#8EA2B8',
  fontWeight: '400',
  margin: 0,
  marginBottom: '8px'
};

const BasicInfoForm = ({ user, onSubmit }) => {
  const useFormMethods = useForm({
    defaultValues: {
      userFirstName: user.userFirstName,
      userLastName: user.userLastName,
      userEmail: user.userEmail,
      userPhone: user.userPhone
    }
  });

  const { handleSubmit } = useFormMethods;

  return (
    <Box pt={2} px={6} width="100%">
      <form id="userInfo" onSubmit={handleSubmit(onSubmit)}>
        <Flex justify="space-between" mb={5} w="100%">
          <Flex direction="column" w="45%">
            <FormInput
              dataAnalyticsId="userFirstName"
              inputName="userFirstName"
              labelName="First Name"
              type={inputTypes.standard}
              useFormMethods={useFormMethods}
              validationRules={{ required: { value: true, message: 'First name is required' } }}
            />
          </Flex>
          <Flex direction="column" w="45%">
            <FormInput
              dataAnalyticsId="userLastName"
              inputName="userLastName"
              labelName="Last Name"
              type={inputTypes.standard}
              useFormMethods={useFormMethods}
              validationRules={{ required: { value: true, message: 'Last name is required' } }}
            />
          </Flex>
        </Flex>
        <Flex justify="space-between" mb={5} w="100%">
          <Flex direction="column" w="45%">
            <FormInput
              dataAnalyticsId="userPhone"
              inputName="userPhone"
              labelName="Phone Number"
              type={inputTypes.phoneNumber}
              useFormMethods={useFormMethods}
              validationRules={getValidationObject(validationTypes.phoneNumberPlain)}
            />
          </Flex>
          <Flex direction="column" w="45%">
            <FormInput
              dataAnalyticsId="userEmail"
              inputName="userEmail"
              labelName="Email Address"
              type={inputTypes.standard}
              useFormMethods={useFormMethods}
              validationRules={{
                required: 'Email is required',
                pattern: {
                  value: /^[a-zA-Z0-9._%-+]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                  message: 'Incorrect email format'
                }
              }}
            />
          </Flex>
        </Flex>
      </form>
    </Box>
  );
};

BasicInfoForm.propTypes = {
  user: PropType.shape({
    roles: PropType.arrayOf(PropType.shape({
      pivot: PropType.shape({
        scopeType: PropType.string,
        scopeId: PropType.number
      })
    })),
    userId: PropType.number,
    userFirstName: PropType.string,
    userLastName: PropType.string,
    userEmail: PropType.string,
    userPhone: PropType.string
  }),
  onSubmit: PropType.func
};

export default BasicInfoForm;
